/**
 * A store for login-sessions
 * Not using cookies anymore but local storage
 * @return {Obiect}
 */
angular.module('mtic')
.service('LoginCookie', function (
    EventManager
) {
    const LOGIN_TOKEN_KEY = 'loginToken';
    const LOCAL_STORAGE = window.localStorage;
    const eventManager = new EventManager('LoginCookie')
    const loginSession = LOCAL_STORAGE.getItem(LOGIN_TOKEN_KEY);
    const sessionLoginTokens = loginSession ? JSON.parse(loginSession) : [];
    let currentSession;

    const updateLastItemLogin = (e, resource) => {
        const slug = resource.slug || resource;
        const targetCookie = sessionLoginTokens.find((value) => {
            return value === currentSession;
        }); 
        if (targetCookie) {
            targetCookie.lastItem = slug;
            saveLoginTokens();
        }
    };
    
    const registerLogin = (username, displayname, userid, sessionkey, firebaseToken, role) => {
        const sessionObject = {
            username: username,
            displayname: displayname,
            userid: userid,
            sessionkey: sessionkey,
            firebaseToken: firebaseToken,
            role,
        }
        currentSession = sessionObject;
        sessionLoginTokens.push(sessionObject);
        saveLoginTokens();
    };

    const saveLoginTokens = () => {
        LOCAL_STORAGE.setItem(LOGIN_TOKEN_KEY, JSON.stringify(sessionLoginTokens));
    }

    eventManager.listen('module:select:resource', updateLastItemLogin.bind(this));
    eventManager.listen('request-next-item', updateLastItemLogin.bind(this));
    const LoginCookie = {
        registerLogin: registerLogin,
        hasSessions: function(){
            // // comment this back to enable
            return sessionLoginTokens.length > 0; 
            // // disabling this at the moment
            // return false;
        },
        getSessionLoginTokens: function(){
            return angular.copy(sessionLoginTokens);
        },
        clearSessions: function(){
            LOCAL_STORAGE.setItem(LOGIN_TOKEN_KEY, JSON.stringify([]));
            sessionLoginTokens.length = 0;
        },
        refreshCookieStore: function(){
            saveLoginTokens();
        }
    }

    //To avoid issues while we are not using this!
    //LoginCookie.clearSessions()

    return LoginCookie;
})
